import React from 'react';

const Widget = props => props.type && <div>{props.type}</div>;

export default Widget;
